<script lang="ts">
    import {onMount} from "svelte";
    import {getCodModeloTasa} from "../utils";
    import {Cart, getCart} from "../models/cart";
    import CatalogPage from "./products/CatalogPage.svelte";

    let cart: Cart;

    export let data: Array<any> = [];
    onMount(() => {
        getCart().then((c) => {
            cart = c;
        });
        const vehicle = getCodModeloTasa();
        data.forEach((item) => {
            item.price_payload.modeloTasa = vehicle;
        });
    });
</script>
<div>
    <CatalogPage {data}
                 {cart}
                 loading={false}
                 showViewMore={false}/>
</div>
